<template>
  <EditorAttributionContainer isPositionReversed :extendedHeight="isSmallTablet">
    <p
      class="edit-in-canva-canvas-tc text-xs w-full text-white font-semi-bold cursor-pointer text-decoration-none flex gap-1 items-center justify-center mb-0"
      v-html="I18n.t('canva_cta.common.tos_link_html', { link: 'https://www.canva.com/policies/terms-of-use/' })"
    />
  </EditorAttributionContainer>
</template>
<script setup lang="ts">
import EditorAttributionContainer from "@/components/prism/editor_attribution_container.vue";
import { useMonitorSize } from "@/composables/monitor_size";
import { inject } from "vue";

const I18n = inject("I18n", window.I18n);

const { isSmallTablet } = useMonitorSize();
</script>

<style lang="scss">
.edit-in-canva-canvas-tc {
  display: inline-block !important;
  text-align: center;

  & a {
    color: white;
  }
}
</style>
